import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import Api from '../../../../../Global/Modules/Api'
const FETCH_URL = "api/educations/incompanyadmin"


class IncompanyKennisNew extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            errors: {}
        }
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        const deita = event.target.elements;
        for (var i = 0; i < deita.length; i++) {
            const e = deita[i] // Form element
            const name = e.name
            const value = e.value

            if (name && value)
                formData.append(name, value)
        }
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)
        formData.append('MemberId', this.props.id)
        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                if (data !== undefined) {
                    Api.print(data)
                    this.setState({ errors: data });
                }
                else {
                    alert('Incompany saved')
                    window.location.href = '/admin/leden/lid/kennis/' + this.props.id
                }
            })


    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="OnbekendeOfIncompanyCursusNaamInstelling">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam Instelling
                    </Col>

                    <Col sm={6}>
                        <FormControl name="institution" type="text" required />
                        {Api.showError(errors, "nameOfInstitution")}
                    </Col>
                </FormGroup>
                <FormGroup controlId="OnbekendeOfIncompanyCursusNameArtikel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam bijeenkomst
                    </Col>

                    <Col sm={6}>
                        <FormControl name="nameArtikel" type="text" required />
                        {Api.showError(errors, "nameArtikel")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyKennisDeelname">
                    <Col componentClass={ControlLabel} sm={4}>
                        Deelname
                    </Col>

                    <Col sm={6}>
                        <FormControl name="courseType" componentClass="select" required>
                            <option value="">selecteer</option>
                            <option value="Spreker">Spreker</option>
                            <option value="Toehoorder">Toehoorder</option>
                        </FormControl>
                        {Api.showError(errors, "courseType")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyKennisDuur">
                    <Col componentClass={ControlLabel} sm={4}>
                        Duur (uren)
                    </Col>

                    <Col sm={6}>
                        <FormControl name="hours" type="text" placeholder="" />
                        {Api.showError(errors, "hours")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyKennisAfgerond">
                    <Col componentClass={ControlLabel} sm={4}>
                        Datum (dd-mm-jjjj)
                    </Col>

                    <Col sm={6}>
                        <FormControl name="date" type="text" required />
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOfIncompanyCursusDeelnamebewijs">
                    <Col componentClass={ControlLabel} sm={4}>
                        Deelnamebewijs
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default IncompanyKennisNew;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/IncompanyKennisNew.js